import React from 'react';
import './PreKFactorsPage.css';
import PageShell from '../components/layout/PageShell';
import PreKFactors from '../components/kfactors/PreKFactors';

const PreKFactorsPage: React.FC = () => {
  return (
    <PageShell>
      <div className="var-container">
        <PreKFactors />
      </div>

    </PageShell>
  );
};

export default PreKFactorsPage;
